import React, { useEffect, useState } from 'react';
import {
    setFormDetailsQuery,
    setFormsQuery,
    useFormsQuery,
} from '../../lib/Queries';
import Loading from '../../components/Loading';
import { businessApiRoute, post } from '../../lib/Api';
import * as Toast from '../../lib/Toast.js';
import useBusinessPostApi from '../../lib/useBusinessPostApi.js';
import { Link, useNavigate } from 'react-router-dom';
import useBusinessNavigate, {
    getBusinessUrl,
} from '../../lib/useBusinessNavigate.js';
import Modal from '../../components/Modal';
import TextInput from '../../components/TextInput';
import DotDotDotMenu from '../../components/DotDotDotMenu';
import TrashIcon from '../../components/icons/TrashIcon.jsx';
import PencilSquareIcon from '../../components/icons/PencilSquareIcon';
import useDelete from '../../lib/useDelete.jsx';
import { useCompleteStep } from '~/lib/Onboarding';
import FormList from '../../components/forms/FormList.jsx';
import SubmissionsList from '../../components/forms/SubmissionsList.jsx';
import SectionPicker from '../../components/SectionPicker.jsx';
import FeatureIntro from '~/components/FeatureIntro.jsx';
import Select from '~/components/Select';
import PageHeading from '~/components/PageHeading';
import SparklesIcon from '~/components/icons/SparklesIcon.jsx';
import AssistantFormEdit from '~/components/assistant/AssistantFormEdit.jsx';
import useIsAssistantEnabled from '~/lib/useIsAssistantEnabled.js';
import AssistantBanner from '~/components/assistant/AssistantBanner.jsx';

const FormsIndexPage = ({}) => {
    const { isSaving, save } = useBusinessPostApi(`/forms/0`);

    const navigate = useBusinessNavigate();
    const [section, setSection] = useState('forms');

    const [formName, setFormName] = useState('');

    const { complete } = useCompleteStep();

    const isAssistantEnabled = useIsAssistantEnabled();

    const [duplicateFormSelection, setDuplicateFormSelection] = useState('0');
    const { isLoading, data } = useFormsQuery();
    const duplicateFormOptions = {
        0: 'Start from scratch',
    };
    (data || []).forEach(
        form => (duplicateFormOptions[`${form.id} `] = form.name),
    );

    const [isAddModalShowing, setIsAddModalShowing] = useState(false);
    const [isAiEditModalShowing, setIsAiEditModalShowing] = useState(false);

    useEffect(() => {
        if (data?.length > 0 && !isAddModalShowing) {
            // Set to the default form
            const id = data.find(f => !!f.is_default_booking)?.id;
            setDuplicateFormSelection(`${id} `);
        }
    }, [data]);

    function submit(ev) {
        ev.preventDefault();

        if (isSaving) return;

        save({
            name: formName,
            duplicate: parseInt(duplicateFormSelection),
        }).then(data => {
            navigate(`/forms/${data.form.id}`);
            complete('forms');
        });
    }

    return (
        <div>
            <PageHeading
                heading="Forms"
                rightContent={
                    <div className="flex gap-2">
                        {/*{isAssistantEnabled && (*/}
                        {/*    <button*/}
                        {/*        className={`btn-light-pill flex items-center ${section === 'forms' ? 'opacity-1' : 'opacity-0'}`}*/}
                        {/*        onClick={() => setIsAiEditModalShowing(true)}*/}
                        {/*    >*/}
                        {/*        <SparklesIcon className="w-4 h-4 mr-2" />*/}
                        {/*        AI Assistant*/}
                        {/*    </button>*/}
                        {/*)}*/}
                        <button
                            className={`btn-pill ${section === 'forms' ? 'opacity-1' : 'opacity-0'}`}
                            onClick={() => setIsAddModalShowing(true)}
                        >
                            {isSaving ? 'Adding...' : 'Add Form'}
                        </button>
                    </div>
                }
            />
            <FeatureIntro>
                Customize forms for scheduling appointments or to collect
                information from clients. Embed forms directly to your site for
                lead capture, scheduling, and more.
            </FeatureIntro>

            {section === 'forms' && (
                <AssistantBanner
                    className="mb-6"
                    description="Tell Breely's Assistant what you want to collect from clients and how the form should work, and it'll set up the fields, scheduling, and other details for you."
                    id="forms"
                    prompt="Help me set up a new form."
                />
            )}

            <div className="flex">
                <SectionPicker
                    className="mb-4"
                    value={section}
                    onChange={setSection}
                    options={[
                        { value: 'forms', label: 'Forms' },
                        { value: 'submissions', label: 'Submissions' },
                    ]}
                />
            </div>

            {section === 'forms' && <FormList />}

            {section === 'submissions' && <SubmissionsList />}

            <Modal
                isOpen={isAddModalShowing}
                onClose={() => {
                    setIsAddModalShowing(false);
                    setFormName('');
                }}
            >
                <form onSubmit={submit}>
                    <TextInput
                        value={formName}
                        onChange={setFormName}
                        autoFocus={isAddModalShowing}
                        id="name"
                        label="Form Name"
                        required={true}
                        inputClassName="w-full max-w-lg"
                        placeholder="ex., Lead Generation Form"
                    />

                    {Object.keys(duplicateFormOptions).length > 1 && (
                        <Select
                            label="Copy Questions & Automations From"
                            options={duplicateFormOptions}
                            onChange={setDuplicateFormSelection}
                            value={duplicateFormSelection}
                            className="mt-4"
                            inputClassName="w-[80%]"
                        />
                    )}
                    <button className="btn-save mt-4">
                        {isSaving ? 'Saving...' : 'Save'}
                    </button>
                </form>
            </Modal>

            {/*<Modal*/}
            {/*    isOpen={isAiEditModalShowing}*/}
            {/*    onClose={() => setIsAiEditModalShowing(false)}*/}
            {/*    widthClass="sm:max-w-[100%] sm:max-h-[80%] sm:my-2 sm:mx-2 !m-0 !rounded-none"*/}
            {/*    panelClassName="!bg-white !p-0 !pl-0"*/}
            {/*>*/}
            {/*    <AssistantFormEdit />*/}
            {/*</Modal>*/}
        </div>
    );
};

export default FormsIndexPage;
